module.exports = require('./helpers/bundle-url').getBundleURL('aoipb') + "logo-dark.eefe0b7f.svg";